import { Injectable } from '@angular/core';
import { GROUP_NAME } from '../../constants/group.constants';
import { UserClaimsService } from 'src/app/shared/service/session/user-claims.service';
@Injectable({ providedIn: 'root' })
export class RoleValidatorService {

  constructor(private readonly userClaimsService: UserClaimsService) {}

  validate(): boolean {
    const claims = this.userClaimsService.getAll();

    if (!claims) return false;

    const userGroups = claims['group'];

    if (!Array.isArray(userGroups) || userGroups.length === 0) {
      console.warn('No existen grupos en las claims.');
      return false;
    }

    const normalizedGroups = userGroups.map(g => g.toUpperCase());
    const allowedGroups = Object.keys(GROUP_NAME); 
    const hasAccess = normalizedGroups.some(g => allowedGroups.includes(g));

    return hasAccess;
  }
}
